// BRO v10 lightweight PLP swatches + Shop All ordering.
// Server-rendered markup owns collection CTA layout. JS handles swatch interaction, above-fold image priority, and Shop All ordering/filter shortcuts.
const broVariantImageCache = new Map();

function broInstallFeaturedCollectionAlignmentStyles() {
  if (document.getElementById('bro-featured-collection-alignment-styles')) return;
  const style = document.createElement('style');
  style.id = 'bro-featured-collection-alignment-styles';
  style.textContent = `
    .bro-featured-aligned .product-grid { align-items: stretch !important; }
    .bro-featured-aligned .product-grid > .grid__item { display:flex!important; flex-direction:column!important; height:100%; min-width:0; }
    .bro-featured-aligned .card-wrapper,
    .bro-featured-aligned .product-card-wrapper { display:flex!important; flex:1 1 auto!important; flex-direction:column!important; width:100%; }
    .bro-featured-aligned .card { flex:1 1 auto; height:100%; }
    .bro-featured-aligned .card__content { flex:1 1 auto; }
    .bro-featured-aligned .card__information { display:flex; flex-direction:column; align-items:center; width:100%; }
    .bro-featured-aligned .card__heading { box-sizing:border-box; width:100%; min-height:63px!important; padding-left:12px!important; padding-right:12px!important; margin-left:auto!important; margin-right:auto!important; }
    .bro-featured-aligned .price { box-sizing:border-box; width:100%; min-height:24px!important; margin-top:2px!important; }
    .bro-featured-aligned .bro-featured-native-swatches { flex:0 0 auto; min-height:36px!important; height:auto!important; margin-top:6px!important; margin-bottom:8px!important; align-content:center; }
    .bro-featured-aligned .bro-featured-view-product { flex:0 0 auto; margin-top:10px!important; }

    .color-swatches-plp .swatch-plp { position:relative; }
    .color-swatches-plp .swatch-plp > .swatch-tooltip {
      position:absolute;
      left:50%;
      bottom:calc(100% + 8px);
      z-index:20;
      display:block;
      max-width:220px;
      padding:6px 9px;
      border-radius:5px;
      background:#22160f;
      color:#fff;
      font-size:12px;
      font-weight:700;
      line-height:1.15;
      white-space:nowrap;
      box-shadow:0 2px 8px rgba(0,0,0,.18);
      opacity:0;
      visibility:hidden;
      pointer-events:none;
      transform:translateX(-50%) translateY(2px);
      transition:opacity .15s ease, transform .15s ease, visibility .15s ease;
    }
    .color-swatches-plp .swatch-plp:hover > .swatch-tooltip,
    .color-swatches-plp .swatch-plp:focus-visible > .swatch-tooltip,
    .color-swatches-plp .swatch-plp:focus > .swatch-tooltip {
      opacity:1;
      visibility:visible;
      transform:translateX(-50%) translateY(0);
    }
    @media (hover:none) {
      .color-swatches-plp .swatch-plp > .swatch-tooltip { display:none; }
    }

    @media screen and (max-width:749px) {
      .bro-featured-aligned .card__heading { min-height:58px!important; padding-left:8px!important; padding-right:8px!important; }
      .bro-featured-aligned .price { min-height:22px!important; }
      .bro-featured-aligned .bro-featured-native-swatches { flex:0 0 auto!important; min-height:32px!important; height:auto!important; margin-top:5px!important; margin-bottom:10px!important; align-content:center!important; position:static!important; }
      .bro-featured-aligned .bro-featured-native-swatches .swatch-plp { position:relative!important; inset:auto!important; transform:none!important; }
      .bro-featured-aligned .bro-featured-view-product { position:relative!important; inset:auto!important; transform:none!important; margin-top:4px!important; }
    }
  `;
  document.head.appendChild(style);
}

function broNormalizeText(value) {
  return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
}

function broShopAllConfig() {
  return window.broShopAllConfig || null;
}

function broIsShopAllPage() {
  return document.documentElement.classList.contains('bro-shop-all-page');
}

function broIsStandardPlpPage() {
  return broIsShopAllPage() || document.documentElement.classList.contains('bro-standard-plp');
}

function broSyncPlpPageClasses() {
  if (broIsShopAllPage()) document.documentElement.classList.add('bro-standard-plp');
}

function broPromoteAboveFoldImages(root = document) {
  const isCollectionOrSearch = /^\/collections\//.test(window.location.pathname) || window.location.pathname === '/search';
  if (!isCollectionOrSearch) return;

  const firstRowCount = window.matchMedia('(max-width: 749px)').matches ? 2 : 4;
  const images = [];
  const seen = new Set();
  const selectors = [
    '.bro-collection-grid__products .card__media img',
    '.bro-product-grid .card__media img',
    '#product-grid .card__media img',
    '.product-grid .card__media img'
  ];

  selectors.forEach(selector => {
    root.querySelectorAll(selector).forEach(image => {
      if (seen.has(image)) return;
      seen.add(image);
      images.push(image);
    });
  });

  images.slice(0, firstRowCount).forEach((image, index) => {
    image.loading = 'eager';
    if ('fetchPriority' in image) image.fetchPriority = index < 2 ? 'high' : 'auto';
  });
}

function broPreloadImage(url, priority = 'low') {
  if (!url) return Promise.resolve(null);
  if (!broVariantImageCache.has(url)) {
    broVariantImageCache.set(url, new Promise(resolve => {
      const image = new Image();
      image.decoding = 'async';
      if ('fetchPriority' in image) image.fetchPriority = priority;
      image.addEventListener('load', () => resolve(image), { once: true });
      image.addEventListener('error', () => resolve(null), { once: true });
      image.src = url;
    }));
  }
  return broVariantImageCache.get(url);
}

function broImageIdentity(url) {
  if (!url) return '';
  try {
    const parsed = new URL(url, window.location.origin);
    return decodeURIComponent(parsed.pathname)
      .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, '')
      .toLowerCase();
  } catch (error) {
    return String(url).split('?')[0].toLowerCase();
  }
}

function broResolveSwatchCard(node) {
  if (!node) return null;
  const directCard = node.closest('.card-wrapper');
  if (directCard) return directCard;
  const item = node.closest('.grid__item');
  return item ? item.querySelector('.card-wrapper') : null;
}

function broSetSelectedSwatch(swatch) {
  const row = swatch && swatch.closest('.color-swatches-plp');
  if (!row) return;
  row.querySelectorAll('.swatch-plp').forEach(button => {
    const selected = button === swatch;
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    button.classList.toggle('bro-swatch-selected', selected);
    button.classList.toggle('bro-shop-all-selected', broIsShopAllPage() && selected);
  });
}

function broClearSelectedSwatches(row) {
  row.querySelectorAll('.swatch-plp').forEach(button => {
    button.setAttribute('aria-pressed', 'false');
    button.classList.remove('bro-swatch-selected', 'bro-shop-all-selected');
  });
}

function broFindInitialSwatch(row) {
  const card = broResolveSwatchCard(row);
  const productImage = card && card.querySelector('.card__media img, .media img');
  if (!productImage) return null;
  const identity = broImageIdentity(productImage.currentSrc || productImage.getAttribute('src') || '');
  if (!identity) return null;
  return Array.from(row.querySelectorAll('.swatch-plp[data-variant-image]')).find(swatch =>
    broImageIdentity(swatch.getAttribute('data-variant-image')) === identity
  ) || null;
}

function broSwapCardImage(swatch) {
  const card = broResolveSwatchCard(swatch);
  const productImage = card && card.querySelector('.card__media img, .media img');
  const variantImage = swatch.getAttribute('data-variant-image');
  if (!productImage || !variantImage) return;
  productImage.decoding = 'async';
  productImage.removeAttribute('srcset');
  productImage.src = variantImage;
}

function broPaintSwatch(swatch) {
  if (!swatch) return;
  const nativeBackground = swatch.getAttribute('data-swatch-background') || '';
  const nativeFocalPoint = swatch.getAttribute('data-swatch-focal-point') || '';

  if (nativeBackground) {
    swatch.style.setProperty('background', nativeBackground, broIsStandardPlpPage() ? 'important' : '');
    if (/^url\(/i.test(nativeBackground)) {
      swatch.style.setProperty('background-size', 'cover', broIsStandardPlpPage() ? 'important' : '');
      swatch.style.setProperty('background-position', nativeFocalPoint || 'center', broIsStandardPlpPage() ? 'important' : '');
      swatch.style.setProperty('background-repeat', 'no-repeat', broIsStandardPlpPage() ? 'important' : '');
    }
  }

  swatch.style.display = 'inline-block';
  swatch.style.visibility = 'visible';
  swatch.style.opacity = '1';
  if (swatch.dataset.broSwatchBound === '1') return;
  swatch.dataset.broSwatchBound = '1';
  swatch.type = 'button';

  const warm = () => {
    const image = swatch.getAttribute('data-variant-image');
    if (image) broPreloadImage(image, 'high');
  };
  swatch.addEventListener('pointerenter', warm, { passive: true });
  swatch.addEventListener('pointerdown', warm, { passive: true });
  swatch.addEventListener('focus', warm);
  swatch.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    broSetSelectedSwatch(swatch);
    broSwapCardImage(swatch);
    if (event.detail > 0) requestAnimationFrame(() => swatch.blur());
  });
}

function broInitializeSwatchRow(row) {
  const swatches = Array.from(row.querySelectorAll('.swatch-plp'));
  const hasRealColorData = swatches.some(swatch => !!swatch.getAttribute('data-swatch-background'));
  if (!hasRealColorData) {
    row.hidden = true;
    row.setAttribute('aria-hidden', 'true');
    return;
  }
  row.hidden = false;
  row.removeAttribute('aria-hidden');
  swatches.forEach(broPaintSwatch);
  if (row.dataset.broInitialSelection === '1') return;
  row.dataset.broInitialSelection = '1';
  const selected = broFindInitialSwatch(row);
  if (selected) broSetSelectedSwatch(selected);
  else broClearSelectedSwatches(row);
}

function broInitializeSwatches(root = document) {
  root.querySelectorAll('.color-swatches-plp').forEach(broInitializeSwatchRow);
}

function broEnhanceFeaturedCollections(root = document) {
  const collections = new Set();
  root.querySelectorAll('.bro-featured-native-swatches').forEach(row => {
    const collection = row.closest('.collection');
    if (collection) collections.add(collection);
  });
  collections.forEach(collection => collection.classList.add('bro-featured-aligned'));
}

function broShopAllCategoryTypes() {
  const configured = (broShopAllConfig() && broShopAllConfig().categoryTypes) || {};
  const normalized = {};
  Object.entries(configured).forEach(([label, types]) => {
    normalized[broNormalizeText(label)] = Array.isArray(types) ? types : [];
  });
  return normalized;
}

function broShopAllFilterForm(root) {
  return root.querySelector('.bro-filter-sidebar [data-bro-filter-form]') || root.querySelector('[data-bro-filter-form]');
}

function broShopAllProductTypeGroup(form) {
  if (!form) return null;
  return Array.from(form.querySelectorAll('.bro-filter-group')).find(group => {
    const summary = group.querySelector('summary');
    return summary && broNormalizeText(summary.textContent).indexOf('product type') === 0;
  }) || null;
}

function broApplyShopAllCategory(root, label) {
  const wanted = broShopAllCategoryTypes()[broNormalizeText(label)] || [];
  if (!wanted.length) return false;
  const form = broShopAllFilterForm(root);
  const group = broShopAllProductTypeGroup(form);
  if (!form || !group) return false;
  group.querySelectorAll('input[type="checkbox"]').forEach(input => {
    input.checked = wanted.includes(String(input.value || '').trim());
  });
  form.submit();
  return true;
}

function broShopAllActiveSort() {
  return new URLSearchParams(window.location.search).get('sort_by') || 'title-ascending';
}

function broShopAllCardHandle(item) {
  const link = item.querySelector('.card__heading a[href*="/products/"]');
  if (!link) return '';
  const raw = ((link.getAttribute('href') || '').split('/products/')[1] || '').split('?')[0].split('#')[0];
  try { return decodeURIComponent(raw); } catch (error) { return raw; }
}

function broShopAllSortGroup(handle) {
  const groups = (broShopAllConfig() && broShopAllConfig().sortGroups) || {};
  const numeric = Number(groups[handle]);
  return Number.isFinite(numeric) ? numeric : 99;
}

function broSortShopAllGrid(root) {
  if (!broIsShopAllPage() || broShopAllActiveSort() !== 'title-ascending') return;
  const grid = root.querySelector('.bro-product-grid');
  if (!grid) return;
  const items = Array.from(grid.children).filter(node => node.classList && node.classList.contains('grid__item'));
  items.sort((a, b) => {
    const groupA = broShopAllSortGroup(broShopAllCardHandle(a));
    const groupB = broShopAllSortGroup(broShopAllCardHandle(b));
    if (groupA !== groupB) return groupA - groupB;
    const titleA = String(a.querySelector('.card__heading a')?.textContent || '').trim();
    const titleB = String(b.querySelector('.card__heading a')?.textContent || '').trim();
    return titleA.localeCompare(titleB, undefined, { sensitivity: 'base' });
  });
  items.forEach(item => grid.appendChild(item));
}

function broRefresh(root = document) {
  broSyncPlpPageClasses();
  broPromoteAboveFoldImages(root);
  broInitializeSwatches(root);
  broEnhanceFeaturedCollections(root);
  if (broIsShopAllPage()) {
    const section = document.querySelector('.bro-filtered-collection');
    if (section) broSortShopAllGrid(section);
  }
}

function broBindShopAllCategoryShortcut() {
  if (!broIsShopAllPage()) return;
  const section = document.querySelector('.bro-filtered-collection');
  if (!section || section.dataset.broShopAllCategoryBound === '1') return;
  section.dataset.broShopAllCategoryBound = '1';
  section.addEventListener('click', event => {
    const category = event.target.closest && event.target.closest('#bro-shop-all-shortcuts a');
    if (!category || !section.contains(category)) return;
    event.preventDefault();
    broApplyShopAllCategory(section, category.textContent);
  });
}

function broBootPlp() {
  broRefresh(document);
  broBindShopAllCategoryShortcut();
}

broInstallFeaturedCollectionAlignmentStyles();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', broBootPlp, { once: true });
} else {
  broBootPlp();
}

document.addEventListener('shopify:section:load', event => broRefresh(event.target || document));